
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/hulft",
      function () {
        return require("private-next-pages/cases/hulft/index.tsx");
      }
    ]);
  